import {TemplateFlagsConfigInterface} from "./templateFlagsConfigInterface";

export const templateFlagsConfig: TemplateFlagsConfigInterface = {
    "series": {
        'serieDetailsModal': false,
    },
    "glazingPackages": {
        'glazingSpacerContainer': true,
    },
    "glazing": {
        'glazingRuleNotice': false,
        'ornamentGlassRuleNotice': false,
        'glazingDetailsModal': false,
        'glazingPartDiscountBanner': false,
        'ornamentsContainer': true,
    },
    "packets": {},
    "handles": {
        'showOutsideHandleSelector': false,
        'showHandleOptionSelector': false,
        'showHandlePositionSelector': false,
        'handlePartDiscountBanner': false,
    },
    "colors": {
        'outsidePaletteContainer': true,
        'insidePaletteContainer': false,
        'ncsSearchBar': false,
        'customColorSearchBar': true,
        'noNcsFoundNotice': false,
        'colorsCustomContainer': true,
        'colorsPredefinedCombinationsContainer': false,
        'predefinedCustomSwitch': false,
    },
    "mullions": {
        'mullionsDefaultPredefinedSetupSelected': true,
        'mullionsCustomPredefinedSetupSelected': false,
        'mullionsDefaultConfigurationsContainer': true,
        'mullionsCustomConfigurationsContainer': false,
        'mullionFieldsContainer': true,
        'muntinFieldsContainer': false,
        'mullionDescription': true,
        'muntinDescription': false,
        'dimensionColorRuleNotice': false,
        'muntinInsideColor': true,
        'diagonalMuntinNotice': false,
        'mullionPVCRulePredefinedCombinationsNotice': false,
        'mullionPVCRuleCustomSetupNotice': false,
        'showMullionAlignment': false,
    },
    "accessories": {
        'showIncludedOptions': false,
        'showAdditionalOptions': false,
        'packetSelectedNotice': false,
    },
    "internalBlindLouvreSelector": {},
    "internalBlindTopRailSelector": {},
    "plisseRailSelector": {},
    "plisseSheatingSelector": {},
    "rollerBlindBoxSelector": {},
    "rollerBlindFabricSelector": {},
    "simpleBlindSelector": {},
    "verticalBlindLouvreSelector": {},
    "verticalBlindTopRailSelector": {},
    "configuratorHeader": {
        "predefinedDimensionInfo": false,
        "predefinedDimensionSelect": false,
        "customDimensionSelect": false,
        "customDimensionsInfo": false,
        "widthError": false,
        "heightError": false,
        "showDimensionInfoModal": false,
        "casementWindowModal": false,
        "hingeSideSelector": true,
        "loadingParameterOverlay": true,
    },
    'addToCartModal': {
        'isInEditMode': false,
        'notInEditMode': false,
        'isSalesman': false,
        'showIncludedOptionsInCartModal': false,
        'showAdditionalOptionsInCartModal': false,
        'showAccessoriesInCartModal': false,
    },
    'app': {
        'currentPrice': false,
        'netPrice': false,
        'regularCustomerPrice': false,
        'noPriceInfo': false,
        'dimensionColorRuleNotice': false,
        'basementWindowRuleNotice': false,
        'maximumDimensionsColorRuleNotice': false,
        'spacerColorChangedNotice': false,
        'showAccessoriesReminderModal': false,
        'muntinColorChangedNotice': false,
        'muntinColorDidntChangeNotice': false,
        'packetsComponent': true,
        'accessoriesComponent': true,
        'handlesComponent': true,
        'materialsComponent': true,
        'typesComponent': true,
    }
};
